import { Card, Clickable } from '@fabric-ds/react';
import * as React from 'react';

const FabricAnchorCard = ({ children, href, className = '' }) => {
    return (
        <Card className={className}>
            <div aria-owns="title" />
            <h3 id="title" className={'m-0'}>
                <Clickable
                    href={href}
                    title="content"
                    className={
                        'link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring'
                    }
                >
                    {children}
                </Clickable>
            </h3>
        </Card>
    );
};

export default FabricAnchorCard;
